/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  useMediaQuery,
  Grow,
  Collapse,
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';

import { useTheme } from '@emotion/react';
import { ExpandLessOutlined, ExpandMoreOutlined } from '@mui/icons-material';
import { getApiCall } from 'api/apiService';
import Down from 'assets/icons/down.svg';
import status from 'assets/icons/status_live.svg';
import VectorUp from 'assets/images/vector_up.png';
import CardHeaderContainer from 'component/CardHeaderContainer/CardHeaderContainer';
import BarChart from 'component/Chart/BarChart';
import BubbleChart from 'component/Chart/BubbleChart';
import LineChart from 'component/Chart/LineChart';
import MeterGaugeChart from 'component/Chart/MeterGaugeChart';
import PieChart from 'component/Chart/PieChart';
import RadarChart from 'component/Chart/RadarChart';
import ScatterChart from 'component/Chart/ScatterChart';
import VariationValueDetails from 'component/VariationValueDetails/VariationValueDetails';
import { EXPANDED_STATUS } from 'constant/app.config';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import StatusLiveCard from 'sharedComponents/StatusLiveCard/StatusLiveCard';
import {
  displayFlex,
  displayFlexColumn,
  fontsize15,
  poppins600,
} from 'theme/common.style';
import { moreInfoContainer, statusCard } from './StatusCardContainer.style';
import { ReactComponent as FilterIcon } from 'assets/icons/FilterIcon.svg';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import ChartModel from 'component/Chart/ModelGraphExpand';
import { ChartFilter } from 'component/Chart/ModelGraphExpandIcons';

const calendar = () => {
  return (
    <svg
      width="176"
      height="31"
      viewBox="0 0 176 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_4913_15470)">
        <rect x="4" y="3" width="168" height="23" rx="4" fill="white" />
      </g>
      <defs>
        <filter
          id="filter0_d_4913_15470"
          x="0"
          y="0"
          width="176"
          height="31"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4913_15470"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4913_15470"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export function Variationbox({ sector1, openModel }) {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Grid
      style={{
        display: 'flex',
        paddingTop: '5px',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: '100%',
        height: '100%',
      }}
    >
      <Card
        style={{
          borderRadius: '8px',
          padding: '15px',
          // margin: "10px",
          marginTop: 0,
          minHeight: '100%',
          boxShadow: 'none',
          minWidth: '98%',
          // display:"flex",
          // flexDirection:"column",
          //  justifyContent:"space-between",
          backgroundColor: '#ffff',
          gap: '20px',
        }}
      >
        <Grid
          container
          sx={{
            display: ' flex',
            flexDirection: 'column',
            justifyContent: ' space-between',
            gap: matchessm || matchesmd ? '0px' : '31px',
          }}
        >
          <Grid item xs={12}>
            <Typography
              sx={{ ...poppins600, fontSize: matchessm ? '12px' : '16px' }}
            >
              {'Current week comparison'}
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ backgroundColor: '#ffff' }}>
            <VariationValueDetails
              sector1={sector1}
              avg={false}
              expanded={openModel}
            />
          </Grid>

          <Grid item xs={12}>
            <VariationValueDetails
              sector1={sector1}
              avg={true}
              expanded={openModel}
            />
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
}

function StatusCardContainer(props) {
  let { getListInfo } = props;
  const [selectedchart, setSelectedchart] = useState('');
  const [selectedcategory, setSelectedcategory] = useState('');
  const [currentweek, setCurrentweek] = useState('');
  const [active, setActive] = useState();
  const [leftColumn1, setLeftColumn1] = useState();
  const [leftColumn2, setLeftColumn2] = useState();
  const [leftColumn3, setLeftColumn3] = useState();
  const [sector1, setSector1] = useState({});
  const [sector2, setSector2] = useState({});
  const [sector3, setSector3] = useState({});
  const propertyData = props?.profileDetails;
  const { listData, title, subTitle, data, tableCalendar, showclick } = props;
  const [ShowOfferCard, setShowOfferCard] = useState(true);
  const params = useParams();

  const [rightDisabled, setRightDisabled] = useState(false);
  const [leftDisabled, setLeftDisabled] = useState(true);

  const [profileDetails, setProfileDetails] = useState({});
  const [buyers, showBuyers] = useState({
    buyers: true,
    activeKey: '',
  });
  const [interested, showInterested] = useState({
    interested: true,
    activeKey: '',
  });
  const [Offers, showOffers] = useState({
    Offers: true,
    activeKey: '',
  });

  const [showMoreDetails, setShowMoreDetails] = useState({
    buyers: false,
    interested: false,
    Offers: false,
    activeKey: '',
  });

  const handleCardClick = async (keyProps, sectorvalue) => {
    if ((showMoreDetails.activeKey !== keyProps && !openModel) || openModel) {
      const selecteddata = keyProps.charAt(0).toUpperCase() + keyProps.slice(1);
      const inputData = {
        propertyId: params?.dashboardId,
      };
      getApiCall(
        EXPANDED_STATUS +
          `/${params?.dashboardId}` +
          `/${selecteddata == 'Buyers' ? 'Inspected' : selecteddata}`
      ).then(async (res) => {
        if (res?.data?.status == -1) {
          toast.error(res?.data?.message, {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            progress: 0,
            theme: 'light',
            style: {
              fontFamily: 'Poppins', // 👈 Inline Poppins font
            },
          });
        } else {
          setCurrentweek(res?.data?.toWeek);
          setSector1(res?.data?.sector1);
          setSector2(res?.data?.sector2);
          setSector3(res?.data?.sector3);
          setLeftColumn1(res?.data?.sector1?.leftColumn);
          setLeftColumn2(res?.data?.sector2?.leftColumn);
          setLeftColumn3(res?.data?.sector3?.leftColumn);
          setShowMoreDetails({
            ...showMoreDetails,
            [keyProps]: true,
            activeKey: keyProps,
          });
          if (sectorvalue) {
            let category =
              keyProps == 'buyers'
                ? 'inspected'
                : keyProps == 'interested'
                ? 'interested'
                : 'offers';
            let chart =
              category == 'inspected' && sectorvalue == 1
                ? 'variation'
                : category == 'inspected' && sectorvalue == 2
                ? 'line'
                : category == 'offers' && sectorvalue == 1
                ? 'offerline'
                : category == 'offers' && sectorvalue == 2
                ? 'bubble'
                : category == 'offers' && sectorvalue == 3
                ? 'scatter'
                : category == 'interested' && sectorvalue == 1
                ? 'bar'
                : category == 'interested' && sectorvalue == 2
                ? 'pie'
                : category == 'interested' && sectorvalue == 3
                ? 'radar'
                : category == 'inspected' && sectorvalue == 3 && 'radar';
            handleClickOpen(chart, category);
          }
        }
      });
    } else {
      setShowMoreDetails({
        ...showMoreDetails,
        activeKey: '',
      });
    }
  };

  const [openModel, setOpenModel] = useState(false);
  const ref = useRef(null);

  const handleClickOpen = (data, category) => {
    setSelectedchart(data);
    setSelectedcategory(category);
    activedata(data, category);
    handleopen();
  };
  const activedata = (data, category) => {
    if (category === 'inspected') {
      if (data === 'variation') {
        setActive('Buyers Section 1');
      } else if (data === 'line') {
        setActive('Buyers Section 2');
      } else {
        if (data === 'radar') {
          setActive('Buyers Section 3');
        }
      }
    } else if (category === 'interested') {
      if (data === 'bar') {
        setActive('Interested Section 1');
      } else if (data === 'pie') {
        setActive('Interested Section 2');
      } else {
        if (data === 'radar') {
          setActive('Interested Section 3');
        }
      }
    } else if (category === 'offers') {
      if (data === 'offerline') {
        setActive('Offers Section 1');
      } else if (data === 'bubble') {
        setActive('Offers Section 2');
      } else {
        if (data === 'scatter') {
          setActive('Offers Section 3');
        }
      }
    } else {
      setActive('');
    }
  };
  const handleopen = () => {
    setOpenModel(true);
  };

  const handleClose = () => {
    setOpenModel(false);
  };

  const theme = useTheme();
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matches = useMediaQuery(theme.breakpoints.down('xl'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matcheslg = useMediaQuery(theme.breakpoints.down('lg'));
  const matches800 = useMediaQuery(theme.breakpoints.down(800));
  const matches500 = useMediaQuery(theme.breakpoints.down(500));
  const matches600 = useMediaQuery(theme.breakpoints.down(600));
  const matches430 = useMediaQuery(theme.breakpoints.down(430));
  const matches900 = useMediaQuery(theme.breakpoints.down(900));

  const [list, setList] = useState();
  useEffect(() => {
    let listdata =
      selectedcategory == 'inspected' && selectedchart == 'variation'
        ? [
            {
              id: 1,
              dataset: 'Inspected Count',
              datasetlabel: 'Inspected Count',
              colorcode: '#0077b6',
              visible: true,
            },
            {
              id: 2,
              dataset: 'Similar Inspected Avg Count',
              datasetlabel: 'Similar Inspected Avg Count',
              colorcode: 'rgb(153, 102, 255)',
              visible: true,
            },
          ]
        : selectedcategory == 'inspected' && selectedchart == 'line'
        ? [
            {
              id: 1,
              dataset: 'Inspected Count',
              datasetlabel: 'User Inspection By Date',
              colorcode: '#0077b6',
              visible: true,
            },
            {
              id: 2,
              dataset: 'Similar Inspected Avg Count',
              datasetlabel: 'Similar User Inspection By Date',
              colorcode: 'rgb(153, 102, 255)',
              visible: true,
            },
          ]
        : selectedcategory == 'offers' && selectedchart == 'offerline'
        ? [
            {
              id: 1,
              dataset: 'Inspected Count',
              datasetlabel: 'Offers Count',
              colorcode: '#0077b6',
              visible: true,
            },
            {
              id: 2,
              dataset: 'Similar Inspected Avg Count',
              datasetlabel: 'Similar Offers Avg Count',
              colorcode: 'rgb(153, 102, 255)',
              visible: true,
            },
          ]
        : selectedcategory == 'offers' && selectedchart == 'bubble'
        ? [
            {
              id: 1,
              dataset: 'Inspected Count',
              datasetlabel: 'Max Offer Price',
              colorcode: '#0077b6',
              visible: true,
            },
            {
              id: 2,
              dataset: 'Similar Inspected Avg Count',
              datasetlabel: 'Similar Avg Max Offer Price',
              colorcode: 'rgb(153, 102, 255)',
              visible: true,
            },
          ]
        : selectedcategory == 'inspected' && selectedchart == 'radar'
        ? [
            {
              id: 1,
              dataset: 'Inspected Count',
              datasetlabel: 'Inspected Count',
              colorcode: '#0077b6',
              visible: true,
            },
            {
              id: 2,
              dataset: 'Similar Inspected Avg Count',
              datasetlabel: 'Similar Inspected Avg Count',
              colorcode: 'rgb(153, 102, 255)',
              visible: true,
            },
          ]
        : selectedcategory == 'interested' && selectedchart == 'radar'
        ? [
            {
              id: 1,
              dataset: 'Inspected Count',
              datasetlabel: 'Interested Parties Count',
              colorcode: '#0077b6',
              visible: true,
            },
            {
              id: 2,
              dataset: 'Similar Inspected Avg Count',
              datasetlabel: 'Similar Interested Parties Count',
              colorcode: 'rgb(153, 102, 255)',
              visible: true,
            },
          ]
        : selectedchart == 'scatter'
        ? [
            {
              id: 1,
              datasetlabel: 'Campaign',
              colorcode: '#0077b6',
              visible: true,
            },
            {
              id: 2,
              datasetlabel: 'Market',
              colorcode: 'rgb(153, 102, 255)',
              visible: true,
            },
          ]
        : selectedchart == 'pie'
        ? [
            {
              id: 1,
              dataset: 'FHB',
              datasetlabel: 'FHB',
              colorcode: 'rgba(0, 119, 182)',
              visible: true,
            },
            {
              id: 2,
              dataset: 'Investor',
              datasetlabel: 'Investor',
              colorcode: 'rgb(3, 4, 94)',
              visible: true,
            },
            {
              id: 3,
              dataset: 'UpSize',
              datasetlabel: 'UpSize',
              colorcode: 'rgb(144, 224, 239)',
              visible: true,
            },
            {
              id: 4,
              dataset: 'DownSize',
              datasetlabel: 'DownSize',
              colorcode: 'rgb(153, 102, 255)',
              visible: true,
            },
            {
              id: 5,
              dataset: 'ReLocate',
              datasetlabel: 'ReLocate',
              colorcode: 'rgb(92, 124, 148)',
              visible: true,
            },
            {
              id: 6,
              dataset: 'Others',
              datasetlabel: 'Others',
              colorcode: 'rgb(0, 180, 216)',
              visible: true,
            },
          ]
        : selectedchart == 'bar'
        ? [
            {
              id: 1,
              dataset: 'Views',
              datasetlabel: 'Views',
              colorcode: 'rgba(0, 119, 182)',
              visible: true,
            },
            {
              id: 2,
              dataset: 'Enquiry',
              datasetlabel: 'Enquiry',
              colorcode: 'rgb(3, 4, 94)',
              visible: true,
            },
            {
              id: 3,
              dataset: 'Inspected',
              datasetlabel: 'Inspected',
              colorcode: 'rgb(144, 224, 239)',
              visible: true,
            },
            {
              id: 4,
              dataset: 'Interested',
              datasetlabel: 'Interested',
              colorcode: 'rgb(153, 102, 255)',
              visible: true,
            },
            {
              id: 5,
              dataset: 'Offers',
              datasetlabel: 'Offers',
              colorcode: 'rgb(92, 124, 148)',
              visible: true,
            },
          ]
        : [];
    setList(listdata);
  }, [selectedcategory, selectedchart]);

  const Filteroption = () => {
    return (
      <>
        <Grid
          sx={{
            display: 'flex',
            // justifyContent:"center"
            alignItems: 'center',
            gap: '16px',
            padding: '15px 0',
            margin: '0 18px',
            //borderBottom: "1px solid #949494",
          }}
        >
          <Typography>
            <ChartFilter />
          </Typography>
          <Typography
            sx={{
              fontFamily: 'poppins',
              fontWeight: 600,
              fontSize: matchessm ? '14px' : '20px',
            }}
          >
            Chart Filter
          </Typography>
        </Grid>
        <Grid
          sx={{
            marginLeft: matchessm ? '40px' : '45px',
          }}
        >
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: 'repeat(1, 1fr)',
                sm: 'repeat(2, 1fr)',
              },
              gap: 1,
              padding: '0px',
            }}
          >
            {list.length > 0 &&
              list.map((item) => (
                <FormGroup key={item.id}>
                  <FormControlLabel
                    sx={{
                      '& .MuiFormControlLabel-label': {
                        fontFamily: 'Poppins',
                        fontSize: matchessm ? '12px' : '16px',
                        color: item?.colorcode,
                      },
                    }}
                    control={
                      <Checkbox
                        disableRipple
                        checked={item?.visible}
                        onChange={(e) => {
                          let index = list.findIndex((x) => x.id === item?.id);
                          let temporaryarray = [...list];
                          temporaryarray[index]['visible'] = e.target.checked;
                          setList(temporaryarray);
                        }}
                        sx={{
                          color: item?.colorcode,
                          '&.Mui-checked': { color: item?.colorcode },
                          '&.MuiCheckbox-root': { color: item?.colorcode },
                        }}
                      />
                    }
                    label={item?.datasetlabel}
                  />
                </FormGroup>
              ))}
          </Box>
        </Grid>
      </>
    );
  };

  return (
    <Card
      variant="outlined"
      sx={{
        ...statusCard,
        borderRadius: matchessm ? '10px' : '5px',
        padding: matchessm ? '11px' : '20px',
      }}
    >
      {!tableCalendar ? (
        <Box sx={{ display: 'flex' }}>
          <CardHeaderContainer
            title={title || ''}
            subTitle={subTitle || ''}
            icon={status}
          />
        </Box>
      ) : (
        <Grid style={displayFlex} sx={{ justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex' }}>
            <CardHeaderContainer
              title={title || ''}
              subTitle={subTitle || ''}
              icon={status}
            />
          </Box>
          <Box
            style={{ display: 'flex' }}
            sx={{ justifyContent: 'end', marginLeft: '-20px' }}
          >
            <Typography
              onClick={() => setShowOfferCard(!ShowOfferCard)}
              sx={{
                border: '1px solid #F0F0F0',
                padding: '8px 5px',
                height: '80%',
                marginLeft: '30px',
                display: 'flex',
                borderRadius: '5px',
                alignItems: 'center',
                // width: !matches600 && "15%",
                justifyContent: 'center',
                alignContent: 'center',
              }}
            >
              {ShowOfferCard ? (
                <ExpandLessOutlined sx={{ color: '#0065FC' }} />
              ) : (
                <ExpandMoreOutlined sx={{ color: '#0065FC' }} />
              )}
            </Typography>
          </Box>
        </Grid>
      )}

      {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label="Pick Date"
          sx={pick_date}
          format="YYYY-MM-DD"
          //  value={enddate}
          onChange={(newValue) => {
            let val = newValue.format("YYYY-MM-DD");
            setEnddate(val.toString());
          }}
        />
      </LocalizationProvider> */}
      {ShowOfferCard && (
        <Grid
          sx={[
            matches700 ? displayFlexColumn : displayFlex,
            // { paddingTop: "5px" },
          ]}
          container
          spacing={2}
        >
          {listData.map((list) => (
            <Grid item xs={matchesmd ? 12 : 4} sx={{ marginTop: '3px' }}>
              <StatusLiveCard
                cardLogo={list.cardLogo}
                cardLogoBgColor={list.cardLogoBgColor}
                cardText={list.cardText}
                cardValue={list.cardValue}
                active={showMoreDetails.activeKey}
                keyVal={list.keyVal}
                cardIndicator={
                  list.cardIndicator === 'vectorup'
                    ? VectorUp
                    : list.cardIndicator === 'vectordown' && Down
                }
                onClickCard={() => handleCardClick(list.keyVal)}
                showclick={showclick}
              />
              {showMoreDetails &&
              showMoreDetails.activeKey === list.keyVal &&
              list.keyVal === 'buyers' &&
              buyers[showMoreDetails.activeKey] &&
              matches900 ? (
                <Grid
                  container
                  // onClick={() => setShowMoreDetails(!buyers)}
                  sx={{
                    ...moreInfoContainer,
                    ...displayFlex,
                    p: '15px',
                    pt: '10px',
                  }}
                >
                  <Grid
                    // xs={matches600?7:9}
                    xs={12}
                    md={4}
                    item
                    sx={{
                      // marginTop: "5px",
                      // marginBottom: "5px",
                      cursor: 'pointer',
                    }}
                    display={'flex'}
                    flexDirection={'column'}
                    justifyContent={'space-between'}
                    onClick={() => {
                      handleClickOpen('variation', 'inspected');
                      setRightDisabled(false);
                      setLeftDisabled(true);
                    }}
                  >
                    <Variationbox sector1={sector1} openModel={openModel} />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={4}
                    onClick={() => {
                      handleClickOpen('line', 'inspected');
                      setRightDisabled(false);
                      setLeftDisabled(false);
                    }}
                    sx={{ cursor: 'pointer' }}
                  >
                    {/*<TotalConversion profileDetails={profileDetails} />*/}
                    <LineChart
                      sector={sector2}
                      offers={false}
                      insbydate={true}
                      getListInfo={getListInfo}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    onClick={() => {
                      handleClickOpen('radar', 'inspected');
                      setRightDisabled(false);
                      setLeftDisabled(false);
                    }}
                    sx={{ cursor: 'pointer' }}
                  >
                    {/*<TotalViews datalists={datalist} counts={count} />{" "}*/}
                    <RadarChart sector={sector3} interested={false} />
                  </Grid>
                </Grid>
              ) : null}
              {showMoreDetails &&
              showMoreDetails.activeKey === list.keyVal &&
              list.keyVal === 'interested' &&
              interested[showMoreDetails.activeKey] &&
              matches900 ? (
                <Grid
                  container
                  // onClick={() => setShowMoreDetails(!interested)}
                  sx={{
                    ...moreInfoContainer,
                    ...displayFlex,
                    p: '15px',
                    pt: '10px',
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    md={4}
                    onClick={() => {
                      handleClickOpen('bar', 'interested');
                      setRightDisabled(false);
                      setLeftDisabled(false);
                    }}
                    sx={{ cursor: 'pointer' }}
                  >
                    <BarChart interestedsector1={sector1} />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    onClick={() => {
                      handleClickOpen('pie', 'interested');
                      setRightDisabled(false);
                      setLeftDisabled(false);
                    }}
                    sx={{ cursor: 'pointer' }}
                  >
                    <PieChart sector2={sector2} />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    onClick={() => {
                      handleClickOpen('radar', 'interested');
                      setRightDisabled(false);
                      setLeftDisabled(false);
                    }}
                    sx={{ cursor: 'pointer' }}
                  >
                    <RadarChart sector={sector3} interested={true} />
                  </Grid>
                </Grid>
              ) : null}

              {showMoreDetails &&
              showMoreDetails.activeKey === list.keyVal &&
              list.keyVal === 'Offers' &&
              Offers[showMoreDetails.activeKey] &&
              matches900 ? (
                <Grid
                  container
                  gap={matchesmd && 1}
                  // onClick={() => setShowMoreDetails(!Offers)}
                  sx={{
                    ...moreInfoContainer,
                    ...displayFlex,
                    p: '15px',
                    pt: '10px',
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    md={4}
                    onClick={() => {
                      handleClickOpen('offerline', 'offers');
                      setRightDisabled(false);
                      setLeftDisabled(false);
                    }}
                    sx={{ cursor: 'pointer' }}
                  >
                    <LineChart
                      sector={sector1}
                      offers={true}
                      getListInfo={getListInfo}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    onClick={() => {
                      handleClickOpen('bubble', 'offers');
                      setRightDisabled(false);
                      setLeftDisabled(false);
                    }}
                    sx={{ cursor: 'pointer' }}
                  >
                    <BubbleChart sector={sector2} />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={4}
                    onClick={() => {
                      handleClickOpen('scatter', 'offers');
                      setRightDisabled(true);
                      setLeftDisabled(false);
                    }}
                    sx={{ cursor: 'pointer' }}
                  >
                    <MeterGaugeChart sector={sector3} />
                  </Grid>
                </Grid>
              ) : null}
            </Grid>
          ))}
        </Grid>
      )}

      {/* {showMoreDetails && showMoreDetails[showMoreDetails.activeKey] */}
      {showMoreDetails && buyers[showMoreDetails.activeKey] && !matches900 ? (
        <Grid
          container
          // onClick={() => setShowMoreDetails(!buyers)}
          sx={{ ...moreInfoContainer, ...displayFlex, p: '15px', pt: '10px' }}
        >
          <Grid
            // xs={matches600?7:9}
            xs={12}
            md={4}
            item
            sx={{
              // marginTop: "5px",
              // marginBottom: "5px",
              cursor: 'pointer',
            }}
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'space-between'}
            onClick={() => {
              handleClickOpen('variation', 'inspected');
              setRightDisabled(false);
              setLeftDisabled(true);
            }}
          >
            <Variationbox sector1={sector1} openModel={openModel} />
          </Grid>

          <Grid
            item
            xs={12}
            md={4}
            onClick={() => {
              handleClickOpen('line', 'inspected');
              setRightDisabled(false);
              setLeftDisabled(false);
            }}
            sx={{ cursor: 'pointer' }}
          >
            {/*<TotalConversion profileDetails={profileDetails} />*/}
            <LineChart
              sector={sector2}
              offers={false}
              insbydate={true}
              getListInfo={getListInfo}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
            onClick={() => {
              handleClickOpen('radar', 'inspected');
              setRightDisabled(false);
              setLeftDisabled(false);
            }}
            sx={{ cursor: 'pointer' }}
          >
            {/*<TotalViews datalists={datalist} counts={count} />{" "}*/}
            <RadarChart sector={sector3} interested={false} />
          </Grid>
        </Grid>
      ) : null}
      {showMoreDetails &&
      interested[showMoreDetails.activeKey] &&
      !matches900 ? (
        <Grid
          container
          // onClick={() => setShowMoreDetails(!interested)}
          sx={{ ...moreInfoContainer, ...displayFlex, p: '15px', pt: '10px' }}
        >
          <Grid
            item
            xs={12}
            md={4}
            onClick={() => {
              handleClickOpen('bar', 'interested');
              setRightDisabled(false);
              setLeftDisabled(false);
            }}
            sx={{ cursor: 'pointer' }}
          >
            <BarChart interestedsector1={sector1} />
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
            onClick={() => {
              handleClickOpen('pie', 'interested');
              setRightDisabled(false);
              setLeftDisabled(false);
            }}
            sx={{ cursor: 'pointer' }}
          >
            <PieChart sector2={sector2} />
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
            onClick={() => {
              handleClickOpen('radar', 'interested');
              setRightDisabled(false);
              setLeftDisabled(false);
            }}
            sx={{ cursor: 'pointer' }}
          >
            <RadarChart sector={sector3} interested={true} />
          </Grid>
        </Grid>
      ) : null}
      {showMoreDetails && Offers[showMoreDetails.activeKey] && !matches900 ? (
        <Grid
          container
          gap={matchesmd && 1}
          // onClick={() => setShowMoreDetails(!Offers)}
          sx={{ ...moreInfoContainer, ...displayFlex, p: '15px', pt: '10px' }}
        >
          <Grid
            item
            xs={12}
            md={4}
            onClick={() => {
              handleClickOpen('offerline', 'offers');
              setRightDisabled(false);
              setLeftDisabled(false);
            }}
            sx={{ cursor: 'pointer' }}
          >
            <LineChart
              sector={sector1}
              offers={true}
              getListInfo={getListInfo}
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
            onClick={() => {
              handleClickOpen('bubble', 'offers');
              setRightDisabled(false);
              setLeftDisabled(false);
            }}
            sx={{ cursor: 'pointer' }}
          >
            <BubbleChart sector={sector2} />
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
            onClick={() => {
              handleClickOpen('scatter', 'offers');
              setRightDisabled(true);
              setLeftDisabled(false);
            }}
            sx={{ cursor: 'pointer' }}
          >
            <MeterGaugeChart sector={sector3} />
          </Grid>
        </Grid>
      ) : null}
      {openModel && (
        <ChartModel
          scrollRef={ref}
          setLeftDisabled={setLeftDisabled}
          setRightDisabled={setRightDisabled}
          leftDisabled={leftDisabled}
          rightDisabled={rightDisabled}
          open={openModel}
          close={handleClose}
          filteroption={<Filteroption />}
          data={
            selectedchart == 'offerline' ? (
              <LineChart
                sector={sector1}
                offers={true}
                insbydate={false}
                list={list}
                getListInfo={getListInfo}
              />
            ) : selectedchart == 'radar' ? (
              <RadarChart
                sector={sector3}
                interested={selectedcategory == 'inspected' ? false : true}
                list={list}
              />
            ) : selectedchart == 'bubble' ? (
              <BubbleChart sector={sector2} list={list} />
            ) : selectedchart == 'pie' ? (
              <PieChart sector2={sector2} list={list} />
            ) : selectedchart == 'bar' ? (
              <BarChart interestedsector1={sector1} list={list} />
            ) : selectedchart == 'variation' ? (
              // <Variationbox sector1={sector1}/>
              <LineChart
                sector={sector1}
                insbydate={false}
                offers={false}
                list={list}
                getListInfo={getListInfo}
              />
            ) : selectedchart == 'line' ? (
              <LineChart
                sector={sector2}
                insbydate={true}
                offers={false}
                list={list}
                getListInfo={getListInfo}
              />
            ) : selectedchart == 'scatter' ? (
              <ScatterChart sector={sector3} list={list} />
            ) : null
          }
          propertyData={propertyData?.PropertyDetails}
          handleCardClick={handleCardClick}
          active={active}
          currentweek={currentweek}
          openModel={openModel}
          variation={sector1}
          leftColumn1={leftColumn1}
          leftColumn2={leftColumn2}
          leftColumn3={leftColumn3}
        />
      )}
    </Card>
  );
}

StatusCardContainer.propTypes = {};

export default StatusCardContainer;
